import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { LangProvider } from './context/LangContext';
import { ProjectProvider } from './context/ProjectContext';
import { EditorProvider, useEditor } from './context/EditorContext';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TemplateCarousel from './components/TemplateCarousel';
import Platforms from './components/Platforms';
import Features from './components/Features';
import Showcase from './components/Showcase';
import Templates from './components/Templates';
import MusicLibrary from './components/MusicLibrary';
import Pricing from './components/Pricing';
import Testimonials from './components/Testimonials';
import CTA from './components/CTA';
import Footer from './components/Footer';
import ProjectPanel from './components/ProjectPanel';
import VideoEditor from './components/VideoEditor';
import SuggestedCreators from './components/SuggestedCreators';
import AuthCallback from './components/AuthCallback';
import VideoView from './components/VideoView';
import MyVideos from './components/MyVideos';
import AlbumView from './components/AlbumView';
import Trends from './components/Trends';
import UserProfile from './components/UserProfile';
import TagView from './components/TagView';
import { Toaster } from './components/ui/toaster';

const EditorMount = () => {
  const { open, closeEditor } = useEditor();
  return <VideoEditor open={open} onClose={closeEditor} />;
};

const Landing = () => (
  <div className="landing-scope min-h-screen bg-white dark:bg-neutral-950 text-neutral-900 dark:text-neutral-100 antialiased transition-colors duration-300">
    <Navbar />
    <main>
      <Hero />
      <TemplateCarousel />
      <SuggestedCreators />
      <Platforms />
      <Features />
      <Showcase />
      <Templates />
      <MusicLibrary />
      <Pricing />
      <Testimonials />
      <CTA />
    </main>
    <Footer />
    <ProjectPanel />
    <EditorMount />
  </div>
);

const AppRouter = () => {
  const location = useLocation();
  // Detect OAuth callback in URL hash synchronously - must be BEFORE routes
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/v/:id" element={<VideoView />} />
      <Route path="/mina-videor" element={<MyVideos />} />
      <Route path="/a/:id" element={<AlbumView />} />
      <Route path="/trends" element={<Trends />} />
      <Route path="/u/:id" element={<UserProfile />} />
      <Route path="/t/:tag" element={<TagView />} />
    </Routes>
  );
};

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <ProjectProvider>
          <EditorProvider>
            <div className="App">
              <BrowserRouter>
                <AppRouter />
              </BrowserRouter>
              <Toaster />
            </div>
          </EditorProvider>
        </ProjectProvider>
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
